var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavPunters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8.796c-2.575 0-4.662-1.969-4.662-4.398C3.338 1.97 5.425 0 8 0c2.575 0 4.662 1.969 4.662 4.398 0 2.43-2.087 4.398-4.662 4.398Zm0-1.912c1.455 0 2.635-1.113 2.635-2.486 0-1.373-1.18-2.486-2.635-2.486-1.455 0-2.635 1.113-2.635 2.486 0 1.373 1.18 2.486 2.635 2.486Zm7.5 10.16c0 .527-.455.956-1.014.956-.559 0-1.013-.429-1.013-.956 0-2.852-2.45-5.163-5.473-5.163-3.023 0-5.473 2.31-5.473 5.163 0 .527-.454.956-1.013.956C.954 18 .5 17.571.5 17.044c0-3.908 3.357-7.075 7.5-7.075s7.5 3.167 7.5 7.075Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavPunters);
export default __webpack_public_path__ + "static/media/nav-punters.dc5437910a52fdab4964f217976d85d9.svg";
export { ForwardRef as ReactComponent };